import { get } from '../../utils/object-helpers';
import { enumTypes } from './enum-types';

$ {
    const title = get(input, 'message.title.textSpans', []);
    const additionalTextList = get(input, 'message.additionalText', []);
    const messageType = get(input, 'message.messageType', '');
    const { allyText, status } = enumTypes(messageType);
    const callToActionText = get(input, 'callToAction.text', '');
    const callToActionUrl = get(input, 'callToAction.action.URL', '');
    const callToActionName = get(input, 'callToAction.action.name', '');
    const callToActionType = get(input, 'callToAction.action.type', '');
    const additionalClasses = get(input, 'class', '');
}

<ebay-page-notice
    a11y-text=allyText
    status=status
    type="page"
    class=`str-status ${additionalClasses}`>
    
    <p><str-text-span textSpans=title /></p>
    <if(additionalTextList.length)>
        <for|additionalText| of=additionalTextList>
            <p><str-text-span textSpans=additionalText.textSpans /></p>
        </for>
    </if>
    <@footer>
        <if(callToActionText)>
            <if(callToActionType === 'OPERATION')>
                <if(callToActionName === 'UPDATE_SHIPPING_LOCATION')>
                    $ {
                         const shippingToLocation = get(input, 'page.modules.SHIPPING_DESTINATION_MODULE.shippingToLocation', null);
                    }
                    <if(shippingToLocation)>
                        <str-shipping-location ...shippingToLocation/>
                    </if>
                </if>
                <else>
                    <ebay-fake-link
                        class="str-status__location-btn"
                        on-click("statusBtnAction", callToActionName)>
                        ${callToActionText}
                    </ebay-fake-link>
                </else>
            </if>
            <else-if(callToActionUrl)>
                <a class="str-status__link" href=callToActionUrl>
                    ${callToActionText}
                </a>
            </else-if>
        </if>
    </@footer>
</ebay-page-notice>
